import { render, staticRenderFns } from "./DentaidAlertBlock.vue?vue&type=template&id=5a5bd1e6&scoped=true"
import script from "./DentaidAlertBlock.vue?vue&type=script&lang=js"
export * from "./DentaidAlertBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bd1e6",
  null
  
)

export default component.exports